import { ApplicationContainer } from "@/components/ApplicationContainer";
import "@/styles/globals.css";
import "@mantine/core/styles/global.css";

import "@mantine/core/styles/Button.css";

import "@mantine/core/styles.layer.css";
import "@mantine/carousel/styles.css";
// ... other styles
import { MantineProvider, DEFAULT_THEME } from "@mantine/core";
import { useRouter } from "next/router";
import Head from "next/head";
import * as gtag from "../lib/gtag";
import { useEffect } from "react";
export default function App({ Component, pageProps }) {
  const router = useRouter();
  useEffect(() => {
    const handleRouteChange = (url) => {
      gtag.pageview(url);
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return (
    <div>
      <Head>
        {/* <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        /> */}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=0.8, minimum-scale=1.0, shrink-to-fit=no"
        />
      </Head>
      <MantineProvider withCssVariables theme={DEFAULT_THEME}>
        <ApplicationContainer>
          <Component {...pageProps} />
        </ApplicationContainer>
      </MantineProvider>
    </div>
  );
}
